import { useMutation, useQuery } from '@tanstack/react-query';
import axiosInstance from '../axios/axiosinstance';

export const useTaxAutofill = (employeeNo) =>
  useQuery({
    queryKey: ['tax-autofill', employeeNo],
    queryFn: () =>
      axiosInstance
        .get(`api/tax-calculator/autofill/${employeeNo}/`)
        .then((r) => r.data),
    enabled: !!employeeNo,
    staleTime: 5 * 60 * 1000,
  });

export const useCalculateTax = () =>
  useMutation({
    mutationFn: (payload) =>
      axiosInstance
        .post('api/tax-calculator/calculate/', payload)
        .then((r) => r.data),
  });
